type UmamiEventData = Record<string, string | number | boolean>;

declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: UmamiEventData) => void;
    };
  }
}

const queuedEvents: Array<{ event: string; data?: UmamiEventData }> = [];

export const isUmamiEnabled = (): boolean =>
  typeof window !== 'undefined' &&
  window.location.hostname === 'leadsme.app' &&
  !!process.env.REACT_APP_UMAMI_WEBSITE_ID;

export const flushUmamiQueue = (): void => {
  if (!window.umami?.track) return;

  queuedEvents.splice(0).forEach(({ event, data }) => {
    window.umami?.track(event, data);
  });
};

export const trackUmamiEvent = (event: string, data?: UmamiEventData): void => {
  if (!isUmamiEnabled()) return;

  try {
    if (window.umami?.track) {
      window.umami.track(event, data);
    } else {
      queuedEvents.push({ event, data });
    }
  } catch {
    // ignore analytics errors
  }
};
